// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Mobile keeps the existing page boxes, without an extra panel or API query. */
.sol-workspace,
.sol-workspace__content {
  display: contents;
}

/* Desktop shows the inbox table or the open request, one at a time, on the
   same wide column. */
@media (min-width: 1024px) {
  .sol-workspace,
  .sol-workspace__content {
    display: block;
    min-width: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/solicitudes/SolicitudesWorkspace.css"],"names":[],"mappings":"AAAA,+EAA+E;AAC/E;;EAEE,iBAAiB;AACnB;;AAEA;sBACsB;AACtB;EACE;;IAEE,cAAc;IACd,YAAY;EACd;AACF","sourcesContent":["/* Mobile keeps the existing page boxes, without an extra panel or API query. */\n.sol-workspace,\n.sol-workspace__content {\n  display: contents;\n}\n\n/* Desktop shows the inbox table or the open request, one at a time, on the\n   same wide column. */\n@media (min-width: 1024px) {\n  .sol-workspace,\n  .sol-workspace__content {\n    display: block;\n    min-width: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
